/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * List of objectives ("demands") of a task for a specific evaluation dimension
 */
export interface DimObjectives {
  /** indicates whether the dimension is applicable to the task */
  applicable: boolean;
  /** list of subtasks or demands of the task that fall under this dimension */
  demands: string[];
}
